"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCart = void 0;

var _lib = require("../lib");

var _documents = require("./documents");

var _excluded = ["data"];

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var useCart = function useCart(orderId) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _useQuery = (0, _lib.useQuery)(_documents.CART, _objectSpread({
    variables: {
      orderId
    },
    fetchPolicy: 'cache-and-network'
  }, options)),
      {
    data
  } = _useQuery,
      rest = _objectWithoutProperties(_useQuery, _excluded);

  var cart = data && data.cart ? data.cart : null;
  var refetchQueries = [{
    query: _documents.CART,
    variables: {
      orderId
    },
    fetchPolicy: 'network-only'
  }];
  var {
    mutate: addSubmissionBase,
    loading: addSubmissionLoading
  } = (0, _lib.useMutation)(_documents.ADD_CART_SUBMISSION, {
    refetchQueries,
    awaitRefetchQueries: true
  });
  var {
    mutate: updateSubmissionBase,
    loading: submissionUpdating
  } = (0, _lib.useMutation)(_documents.UPDATE_CART_SUBMISSION, {
    refetchQueries,
    awaitRefetchQueries: true
  });
  var {
    mutate: checkoutBase,
    loading: checkoutLoading
  } = (0, _lib.useMutation)(_documents.CHECKOUT_CART);

  var addSubmission = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(function* (input) {
      return addSubmissionBase({
        orderId,
        submission: input
      });
    });

    return function addSubmission(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var updateSubmission = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(function* (submissionId, input) {
      return updateSubmissionBase({
        orderId,
        submissionId,
        submission: input
      });
    });

    return function updateSubmission(_x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();

  var checkout = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(function* (payment) {
      return checkoutBase({
        orderId,
        payment
      });
    });

    return function checkout(_x4) {
      return _ref3.apply(this, arguments);
    };
  }();

  return _objectSpread({
    cart,
    addSubmission,
    addSubmissionLoading,
    updateSubmission,
    submissionUpdating,
    checkout,
    checkoutLoading
  }, rest);
};

exports.useCart = useCart;